<template>
    <div class="menu-second">
        <div class="menu-second">
            <div class="menu-title">
                <span>满送</span>
            </div>
            <div class="menu-list">
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/mansong/list.html'}">满送列表</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "left"
    }
</script>

<style scoped>

</style>
